import { Box, Join, Space } from '@gousto-internal/citrus-react'
import React from 'react'
import { MobileOrderTabItem } from './MobileOrderTabItem'
import { OrderTabItem } from './OrderTabItem'
import type { OrderTab } from './OrderTabs.types'

const MOBILE_FIXED_TAB_WIDTH_PX = 100

type OrderTabsProps = {
  orderTabs: OrderTab[]
  activeIndex: number
  onChange: (index: number) => void
  variant?: 'desktop' | 'mobile'
}
export type { OrderTab } from './OrderTabs.types'

export function OrderTabs({
  orderTabs,
  activeIndex,
  onChange,
  variant = 'desktop',
}: OrderTabsProps) {
  if (variant === 'mobile') {
    const isFourTabs = orderTabs.length === 4
    const isScrollable = orderTabs.length > 4

    return (
      <Box
        data-testid="mobile-order-tabs-wrapper"
        width="100%"
        style={{
          display: 'flex',
          gap: '0px',
          justifyContent: 'flex-start',
          overflowX: isScrollable ? 'auto' : 'visible',
        }}
      >
        {orderTabs.map((tab, index) => (
          <MobileOrderTabItem
            key={tab.order_id}
            index={index}
            tab={{
              date_title: tab.date_title,
              discount: tab.discount,
              icon: tab.icon,
              isActive: index === activeIndex,
            }}
            onActivate={onChange}
            style={
              isFourTabs
                ? { flex: '1 1 0', width: '25%' }
                : {
                    flex: `0 0 ${MOBILE_FIXED_TAB_WIDTH_PX}px`,
                    width: `${MOBILE_FIXED_TAB_WIDTH_PX}px`,
                  }
            }
          />
        ))}
      </Box>
    )
  }

  return (
    <Join with={<Space size={3} />}>
      {orderTabs.map((tab, index) => (
        <OrderTabItem
          key={tab.order_id}
          index={index}
          tab={{
            date_title: tab.date_title,
            discount: tab.discount,
            icon: tab.icon,
            isActive: index === activeIndex,
          }}
          onActivate={onChange}
        />
      ))}
    </Join>
  )
}
